<!-- Одинаковые действия смены статуса в карточке, таблице и форме ремонта. -->
<template>
  <BaseStatusSelect :compact="compact" :value="repair.status"
    :label="store.formatStatus(repair.status)" :color="store.statusColor(repair.status)"
    :options="disabled || store.isSubmitting ? [] : store.statusOptions" @change="startTransition" />
  <Teleport to="body">
    <RecordListStatusTransitionModal v-if="transition" visible :title="title"
      form-id="fleet-repair-transition" :is-submitting="store.isSubmitting" @close="close">
      <TransitionForm :repair="repair" :key="transition" :status="transition" :is-submitting="store.isSubmitting" @submit="saveTransition" />
    </RecordListStatusTransitionModal>
  </Teleport>
</template>
<script>
import RecordListStatusTransitionModal from "@/components/RecordList/StatusTransition/Modal.vue";
import TransitionForm from "@/components/Fleet/Repair/Status/Form.vue";
import { useFleetRepairStore } from "@/stores/fleetRepairStore";

export default {
  name: "FleetRepairStatusSelect",
  components: { TransitionForm, RecordListStatusTransitionModal },
  props: {
    repair: { type: Object, required: true },
    compact: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ["changed"],
  data() { return { transition: null }; },
  computed: {
    store() { return useFleetRepairStore(); },
    title() {
      return { done: "Зафиксировать выполнение", cancelled: "Отменить ремонт", planned: "Вернуть в запланированные" }[this.transition];
    },
  },
  watch: {
    "repair.id"() { this.transition = null; },
  },
  methods: {
    async startTransition(status) {
      if (this.disabled || this.store.isSubmitting || this.repair.status === status) return;
      if (status === "in_progress") {
        const repair = await this.store.transitionRepair(this.repair.id, status);
        this.$emit("changed", repair);
      } else {
        this.transition = status;
      }
    },
    close() {
      if (!this.store.isSubmitting) this.transition = null;
    },
    async saveTransition({ status, comment, completed_at, remark_ids }) {
      if (this.store.isSubmitting) return;
      const payload = status === "done" ? { comment, completed_at, remark_ids } : { comment };
      const repair = await this.store.transitionRepair(this.repair.id, status, payload);
      this.transition = null;
      this.$emit("changed", repair);
    },
  },
};
</script>
